import React, { memo, useEffect, useState } from "react";
import useResponsive from "../../../../Hooks/useResponsive";
import { Box, Card, CardContent, Chip, Stack } from "@mui/material";
import { motion } from "framer-motion";

const StudentDetailsCard = memo(({ studentDetails }) => {
  const [direction, setDirection] = useState("row");
  const mdDown = useResponsive("down", "md");
  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);
  return (
    <Box sx={{ width: "100%" }}>
      {/* <motion.div initial={{ y: -200, x: 0, opacity: 0 }} animate={{ y: 0, x: 0, opacity: 1 }} transition={{ duration: 0.8 }}> */}
      <Card
        sx={{
          background: "linear-gradient(125deg, #51475bff, #792191ff)",
          color: "#fff",
          borderRadius: 1,
          width: "100%",
        }}
      >
        <CardContent sx={{ padding: "11px !important" }}>
          <Stack spacing={1} direction={direction} justifyContent="center">
            <Chip
              variant="outlined"
              label={`Name : ${studentDetails?.name || "Not Available"}`}
              sx={{
                backgroundColor: "white",
                color: "#000000",
                fontWeight: 500,
                fontSize: "1rem",
                px: 2,
              }}
            />
            <Chip
              variant="outlined"
              label={`Mobile No : ${studentDetails?.mobileNumber || "Not Available"}`}
              sx={{
                backgroundColor: "white",
                color: "#000000",
                fontWeight: 500,
                fontSize: "1rem",
                px: 2,
              }}
            />
            {/* <Chip
              variant="outlined"
              label={`Course : ${studentDetails?.course || "Not Available"}`}
              sx={{
                backgroundColor: "white",
                color: "#000000",
                fontWeight: 500,
                fontSize: "1rem",
                px: 2,
              }}
            /> */}
            <Chip
              variant="outlined"
              label={`Class : ${studentDetails?.class || "Not Available"}`}
              sx={{
                backgroundColor: "white",
                color: "#000000",
                fontWeight: 500,
                fontSize: "1rem",
                px: 2,
              }}
            />
          </Stack>
        </CardContent>
      </Card>
      {/* </motion.div> */}
    </Box>
  );
});

export default StudentDetailsCard;
